import ServiceCRUD from '../../../services/ServiceCRUDFLEXUC';

class PJSIPConfiguration extends ServiceCRUD {
  constructor() {
    super('/api/audios');
  }
}

export default new PJSIPConfiguration();
